import { render, staticRenderFns } from "./ServiceAgreementTwo.vue?vue&type=template&id=4d40b8e4&scoped=true"
import script from "./ServiceAgreementTwo.vue?vue&type=script&lang=js"
export * from "./ServiceAgreementTwo.vue?vue&type=script&lang=js"
import style0 from "./ServiceAgreementTwo.vue?vue&type=style&index=0&id=4d40b8e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d40b8e4",
  null
  
)

export default component.exports